import DOMPurify from "dompurify";

export const LIMITE_CONTEUDO_HTML = 20000;

const CONFIG_SANITIZE = {
  ALLOWED_TAGS: [
    "p",
    "br",
    "strong",
    "b",
    "em",
    "i",
    "u",
    "s",
    "strike",
    "ol",
    "ul",
    "li",
    "h1",
    "h2",
    "h3",
    "blockquote",
    "span",
  ],
  ALLOWED_ATTR: ["class"],
};

function escaparHtml(texto) {
  return texto
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function sanitizarHtmlMensagem(html) {
  return DOMPurify.sanitize(html || "", CONFIG_SANITIZE);
}

export function conteudoMensagemVazio(html) {
  const texto = sanitizarHtmlMensagem(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
  return !texto;
}

export function htmlParaExibicao(conteudo) {
  const bruto = conteudo || "";
  if (!/<[a-z][\s\S]*>/i.test(bruto)) {
    return escaparHtml(bruto).replace(/\n/g, "<br />");
  }
  return sanitizarHtmlMensagem(bruto);
}
